'use strict';

require('./input.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Input = _react2['default'].createClass({
    displayName: 'Input',

    propTypes: {
        autoFocus: _react2['default'].PropTypes.bool,
        defaultValue: _react2['default'].PropTypes.string,
        placeholder: _react2['default'].PropTypes.string,
        className: _react2['default'].PropTypes.string,
        inputName: _react2['default'].PropTypes.string,
        error: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.bool]),
        errorMessage: _react2['default'].PropTypes.string,
        errorClass: _react2['default'].PropTypes.string,
        handleChange: _react2['default'].PropTypes.func,
        onKeyDown: _react2['default'].PropTypes.func,
        onBlur: _react2['default'].PropTypes.func,
        onFocus: _react2['default'].PropTypes.func,
        disabled: _react2['default'].PropTypes.bool,
        type: _react2['default'].PropTypes.string,
        value: _react2['default'].PropTypes.string
    },
    getDefaultProps: function getDefaultProps() {
        return {
            disabled: false,
            errorClass: 'c-red',
            type: 'text'
        };
    },
    getInitialState: function getInitialState() {
        return { error: false };
    },
    handleChange: function handleChange(event) {
        this.props.handleChange(event.target.value, event);
    },
    setDisabled: function setDisabled(val) {
        this.props.disabled = val;
    },
    setErrorMessage: function setErrorMessage(val) {
        if (typeof val === 'string') {
            this.props.errorMessage = val;
        }
    },
    render: function render() {
        var _React$createElement;

        var errorMsg = '';

        var divClasses = {
            'm-input': true,
            'm-input-error': this.props.error
        };
        divClasses[this.props.className] = this.props.className;
        divClasses = (0, _classnames2['default'])(divClasses);
        if (this.props.errorMessage) {
            var errorDivClasses = {
                'm-input-error-message': true
            };
            if (this.props.errorClass) {
                errorDivClasses[this.props.errorClass] = true;
            }
            errorDivClasses = (0, _classnames2['default'])(errorDivClasses);

            errorMsg = _react2['default'].createElement(
                'div',
                { className: 'm-input-error' },
                _react2['default'].createElement('img', { src: require('./error_x@2x.png'), className: 'm-input-error-message-img' }),
                _react2['default'].createElement(
                    'p',
                    { className: errorDivClasses },
                    this.props.errorMessage
                )
            );
        }

        return _react2['default'].createElement(
            'div',
            { className: divClasses },
            _react2['default'].createElement('input', (_React$createElement = { type: 'text',
                autoFocus: this.props.autoFocus,
                name: this.props.inputName,
                className: 'm-input-text',
                maxLength: '99',
                placeholder: this.props.placeholder,
                disabled: this.props.disabled,
                onFocus: this.props.onFocus,
                onBlur: this.props.onBlur,
                onKeyDown: this.props.onKeyDown,
                onChange: this.handleChange,
                defaultValue: this.props.defaultValue,
                tabIndex: this.props.tabIndex || 0
            }, _defineProperty(_React$createElement, 'type', this.props.type), _defineProperty(_React$createElement, 'value', this.props.value), _React$createElement)),
            errorMsg
        );
    }
});
module.exports = Input;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/input.jsx
 ** module id = 699
 ** module chunks = 0
 **/